import React from 'react';
import {CssBaseline, ThemeProvider} from "@mui/material";
import theme from "theme";
import {RouterProvider} from "react-router-dom";
import router from "./router";
import {ApolloProvider} from "@apollo/client";
import client from "./config/apolloCondig";
import 'bvi/dist/css/bvi.css';

function App() {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router}/>
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
